import React from "react";
import { useTheme } from "@mui/material";
import { ORG_ROLE_DESCRIPTION, roleLabel } from "../../utils/organisationApi";

// Radio list of roles with the one-line description from spec 3.1
const RoleOptions = ({ name, roles, value, onChange, legend = "Role" }) => {
  const theme = useTheme();
  return (
    <fieldset>
      <legend className="block text-sm font-medium mb-2">
        {legend} <span className="text-red-500">*</span>
      </legend>
      <div className="flex flex-col gap-2">
        {roles.map((role) => {
          const checked = value === role;
          return (
            <label
              key={role}
              className="flex items-start gap-3 p-3 border rounded-md cursor-pointer"
              style={{
                borderColor: checked ? theme.palette.info.main : theme.palette.secondary.v4,
                backgroundColor: checked ? "#f3f6fc" : theme.palette.primary.main,
              }}
            >
              <input
                type="radio"
                name={name}
                value={role}
                checked={checked}
                onChange={() => onChange(role)}
                className="mt-1"
              />
              <span>
                <span className="block font-medium">{roleLabel(role)}</span>
                <span className="block text-sm text-accent-gray-light">{ORG_ROLE_DESCRIPTION[role]}</span>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
};

export default RoleOptions;
